<template>
  <div class="row">
    <div class="col-12">
      <form novalidate @submit.prevent="saveBookingDetails" id="bookerForm">
        <div class="card hg-topline" :style="topLineOverride">
          <div class="card-body">
            <div class="container">
              <div class="row">
                <div class="col col-12 col-md-6" v-for="col in formColumns">

                  <div class="form-group" v-if="showFieldForColumn(col, 'a')">
                    <label for="titledropdown">Title</label>
                    <select v-validate="'required'" data-vv-as="title" data-vv-validate-on="blur" class="form-control" id="titledropdown" name="titledropdown" required v-model="registrationResponses.title">
                      <option style="color: red" :value="null">
                        --Please Select A Title --
                      </option>
                      <option value="Mr">
                        Mr
                      </option>
                      <option value="Mrs">
                        Mrs
                      </option>
                      <option value="Miss">
                        Miss
                      </option>
                      <option value="Ms">
                        Ms
                      </option>
                      <option value="Dr">
                        Doctor
                      </option>
                      <option value="Prof">
                        Professor
                      </option>
                      <option value="Other">
                        Other
                      </option>
                    </select>
                    <span v-show="errors.has('titledropdown')" class="invalid-feedback">{{ errors.first('titledropdown') }}</span>
                  </div>

                  <div class="form-group" v-if="showFieldForColumn(col, 'b')">
                    <label for="forename">Forename</label>
                    <input v-validate="'required'" data-vv-validate-on="blur" class="form-control" id="forename" maxlength="100" name="forename" placeholder="Name" required="" type="text" v-model="registrationResponses.forename">
                    <span v-show="errors.has('forename')" class="invalid-feedback">{{ errors.first('forename') }}</span>
                  </div>

                  <div class="form-group" v-if="showFieldForColumn(col, 'c')">
                    <label for="surname">Surname</label>
                    <input v-validate="'required'" data-vv-validate-on="blur" class="form-control" id="surname" maxlength="100" name="surname" placeholder="Surname" required="" type="text" v-model="registrationResponses.surname">
                    <span v-show="errors.has('surname')" class="invalid-feedback">{{ errors.first('surname') }}</span>
                  </div>

                  <div class="form-group" v-if="event.company_field && showFieldForColumn(col, 'd')">
                    <label for="company">Company</label>
                    <input v-validate="'required'" data-vv-validate-on="blur" class="form-control" id="company" maxlength="100" name="company" placeholder="Company" required="" type="text" v-model="registrationResponses.company">
                    <span v-show="errors.has('company')" class="invalid-feedback">{{ errors.first('company') }}</span>
                  </div>

                  <div class="form-group" v-if="event.job_description_field && showFieldForColumn(col, 'e')">
                    <label for="job">Job Title</label>
                    <input class="form-control" id="job" maxlength="100" name="job" placeholder="Job Title" required="" type="text" v-model="registrationResponses.job_description">
                    <span v-show="errors.has('job')" class="invalid-feedback">{{ errors.first('job') }}</span>
                  </div>

                  <div class="form-group" v-if="showFieldForColumn(col, 'f')">
                    <label for="login_email">Email</label>
                    <input v-validate="'required|email'" class="form-control" data-vv-validate-on="blur" id="login_email" maxlength="200" name="email" placeholder="Email" required="" type="email" v-model.trim="registrationResponses.email">
                    <span v-show="errors.has('email')" class="invalid-feedback">{{ errors.first('email') }}</span>
                  </div>

                  <div class="form-group" v-if="event.phone_field && showFieldForColumn(col, 'g')">
                    <label for="phone">Phone Number</label>
                    <input v-validate="'required'" class="form-control" id="phone" maxlength="15" name="phone" placeholder="Phone Number" required="" type="text" v-model="registrationResponses.phone">
                    <span v-show="errors.has('phone')" class="invalid-feedback">{{ errors.first('phone') }}</span>
                  </div>

                  <div class="form-group" v-if="event.address1_field && showFieldForColumn(col, 'h')">
                    <label for="login_Address1">Address 1</label>
                    <input class="form-control" id="login_Address1" maxlength="100" name="address1" placeholder="Address 1" required="" type="text" v-model="registrationResponses.address1">
                    <span v-show="errors.has('address1')" class="invalid-feedback">{{ errors.first('address1') }}</span>
                  </div>

                  <div class="form-group" v-if="event.address2_field && showFieldForColumn(col, 'i')">
                    <label for="login_Address2">Address 2</label>
                    <input class="form-control" id="login_Address2" maxlength="100" name="address2" placeholder="Address 2" required="" type="text" v-model="registrationResponses.address2">
                    <span v-show="errors.has('address2')" class="invalid-feedback">{{ errors.first('address2') }}</span>
                  </div>

                  <div class="form-group" v-if="event.town_field && showFieldForColumn(col, 'j')">
                    <label for="login_town">Town/City</label>
                    <input class="form-control" id="login_town" maxlength="100" name="town" placeholder="Town/City" required="" type="text" v-model="registrationResponses.town">
                    <span v-show="errors.has('town')" class="invalid-feedback">{{ errors.first('town') }}</span>
                  </div>

                  <div class="form-group" v-if="event.county_field && showFieldForColumn(col, 'k')">
                    <label for="login_County">County</label>
                    <input class="form-control" id="login_County" maxlength="60" model="county" name="county" placeholder="County" required="" type="text" v-model="registrationResponses.county">
                    <span v-show="errors.has('county')" class="invalid-feedback">{{ errors.first('county') }}</span>
                  </div>

                  <div class="form-group" v-if="event.postcode_field && showFieldForColumn(col, 'l')">
                    <label for="login_PostCode">Postcode</label>
                    <input class="form-control" id="login_PostCode" maxlength="8" name="postcode" placeholder="PostCode" required="" type="text" v-model="registrationResponses.postcode">
                    <span v-show="errors.has('postcode')" class="invalid-feedback">{{ errors.first('postcode') }}</span>
                  </div>

                  <div class="form-group" v-if="event.country_field && showFieldForColumn(col, 'm')">
                    <label for="countries">Country</label>
                    <b-form-select v-model="registrationResponses.country" text-field="name" :options="countries" />
                    <span v-show="errors.has('countries')" class="invalid-feedback">{{ errors.first('countries') }}</span>
                  </div>

                  <div class="form-group" v-if="event.po_number_field && showFieldForColumn(col, 'n')">
                    <label for="login_po_number">PO Number</label>
                    <input class="form-control" id="login_po_number" maxlength="20" name="po_number" placeholder="PO Number" type="text" v-model="registrationResponses.po_number">
                  </div>

                  <template v-for="(cus_field, idx) in regFields">
                    <template v-if="showFieldForColumn(col, ( 'o' + idx))">
                      <div class="form-group" v-if="(cus_field.question_type=='text' || cus_field.question_type=='number' )">
                        <label>{{cus_field.title}}</label>
                        <input v-if="!preview" :id="`${cus_field.title}_${idx}`" v-validate="event.booker_questions_mandatory ? 'required' : ''" class="form-control" maxlength="200" :type="cus_field.question_type" v-model="registrationResponses.registered_user_responses_attributes[idx].text" :name="`${cus_field.title}_${idx}`"  :data-vv-as="cus_field.title" :key="idx" data-vv-validate-on="blur">
                        <input v-if="preview" class="form-control" maxlength="200" :type="cus_field.question_type">
                        <span v-show="errors.has(`${cus_field.title}_${idx}`)" class="invalid-feedback">{{ errors.first(`${cus_field.title}_${idx}`)}}</span>
                      </div>

                      <div class="form-group" v-else>
                        <label :for="`${cus_field.title}_${idx}`">{{cus_field.title}}</label>
                        <select v-if="!preview " v-validate="event.booker_questions_mandatory ? 'required' : ''" class="form-control" :id="`${cus_field.title}_${idx}`" :name="`${cus_field.title}_${idx}`" v-model="registrationResponses.registered_user_responses_attributes[idx].selected_option"  :data-vv-as="cus_field.title" :key="idx">
                          <option v-for="f in cus_field.options">
                            {{f}}
                          </option>
                        </select>
                        <select v-if="preview " class="form-control" id="customs" name="customs">
                          <option v-for="f in cus_field.options">
                            {{f}}
                          </option>
                        </select>
                        <span v-show="errors.has(`${cus_field.title}_${idx}`)" class="invalid-feedback">{{ errors.first(`${cus_field.title}_${idx}`)}}</span>
                      </div>
                    </template>
                  </template>

                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import EventBus from "./../../events/event-bus";
import countries from "./../common/countries";

export default {
  props: ["event", "preview", "regUserId"],

  mixins: [countries],

  data() {
    return {
      posArray: [],
      fieldsCount: 4,
      splitValue: 0,
      registrationResponses: {},
      registered_user_responses_attributes: [],
      regFields: [],
      viewonly: false,
      submitted: false,
      formColumns: [1, 2],
      readonly: this.$store.getters.getReadOnly
    };
  },

  created() {
    var self = this;

    if (this.regUserId) {
      this.$http
        .get("/registered_users/" + this.regUserId + "/delegate_details/")
        .then(function(response) {
          console.log(response.data);
          self.registrationResponses = response.data;
          self.setupForm();
        });
    } else {
      self.setupForm();
    }
  },

  computed: {
    regFieldName(idx) {
      "custom_" + idx;
    },

    topLineOverride() {
      return { borderTop: "4px solid " + this.event.phcolour };
    }
  },

  methods: {
    setupForm() {
      var self = this;
      this.posArray = [];
      this.regFields = [];
      this.fieldsCount = 4; //reset this if calling from outside
      this.splitValue = 0;
      this.registrationResponses.registered_user_responses_attributes =
        this.registrationResponses.registered_user_responses || [];

      this.registered_user_responses_attributes = this.registrationResponses.registered_user_responses_attributes;

      if (this.event.company_field) this.fieldsCount++;
      if (this.event.job_description_field) this.fieldsCount++;
      if (this.event.phone_field) this.fieldsCount++;
      if (this.event.address1_field) this.fieldsCount++;
      if (this.event.address2_field) this.fieldsCount++;
      if (this.event.town_field) this.fieldsCount++;
      if (this.event.county_field) this.fieldsCount++;
      if (this.event.country_field) this.fieldsCount++;
      if (this.event.po_number_field) this.fieldsCount++;

      var regFields = this.event.registration_fields.filter(
        field => field.field_type === "booker" && !field._destroy
      );

      this.fieldsCount = this.fieldsCount + regFields.length;

      this.splitValue = Math.ceil(this.fieldsCount / 2);

      if (regFields) {
        var customFields = regFields;

        var customFieldsSorted = customFields.sort((n1, n2) => {
          if (n1.order_index > n2.order_index) {
            return 1;
          }
          if (n1.order_index < n2.order_index) {
            return -1;
          }
          return 0;
        });

        // Forces the correct order of responses dependent on the order of the questions
        var result = [];
        if (
          this.registered_user_responses_attributes &&
          this.registered_user_responses_attributes.length > 0
        ) {
          customFieldsSorted.forEach(field => {
            var match = this.registered_user_responses_attributes.find(
              resp => resp.registration_field_id == field.id
            );
            if (match) {
              result.push(match);
            }
          });
        }
        if (result.length > 0) {
          this.registrationResponses.registered_user_responses_attributes = result;
        }

        customFieldsSorted.forEach(function(customField, index) {
          self.registered_user_responses_attributes.push({
            registration_field_id: customField.id,
            text: null,
            selected_option: null
          });

          var optionVals = [];
          //TODO Should be filtered on server
          if (customField.field_type == "booker") {
            if (customField.question_type == "select") optionVals = [];

            var regField = {
              order_index: customField.order_index,
              field_id: customField.id,
              title: customField.title,
              field_type: customField.field_type,
              question_type: customField.question_type,
              mandatory: customField.mandatory,
              min_length: customField.min_length,
              max_length: customField.max_length,
              options: customField.options
            };

            //self.regFields.push(regField);
            self.$set(self.regFields, index, regField);
          }
        });
      }
    },

    showFieldForColumn: function(col, position) {
      var pos = this.posit(position);

      if (pos == 0) {
        return true;
      }

      if (col == 1) {
        return pos <= this.splitValue;
      } else {
        return pos > this.splitValue;
      }
    },

    posit(posName) {
      if (this.posArray.indexOf(posName) == -1) {
        this.posArray.push(posName);
      }
      return this.posArray.indexOf(posName) + 1;
    },

    saveBookingDetails() {
      this.$store.commit("setBookerDetails", this.registrationResponses);
      return this.$validator.validateAll();
    }
  }
};
</script>
